
<iframe [style.height]="innerHeight" id="PluginAcquisitiIframe" style="width: 100%;" [src]="certurl | safe" title="Plugin Acquisti"></iframe>
